/* ---- Network Requests ---- */
/**
 * Fetch the catalog item data from reware based on provided parent SKU inputted by user.
 * @param {*} parentSku
 * @param {*} partnerUuid
 * @returns
 */
async function fetchSku(parentSku, partnerUuid) {
  const query = `
    query tradeinItemConditionValues(
      $partnerUuid: String!
      $parentSku: String!
      $displayType: String!
    ) {
      tradeinItemConditionValues(partnerUuid: $partnerUuid, parentSku: $parentSku, displayType: $displayType) {
        parentSku
        catalogItemTitle
        catalogItemBrand
        itemImageUrl
        availabilityMiti
        images {
          tag
          url
        }
        conditionValues {
          tradeinValue
          displayTradeinValue
          condition {
            name
            displayName
            rank
          }
        }
        colorVariants {
          name
          displayName
          url
          type
          code
        }
        category
        categoryDisplay
        rubricCode
      }
    }
  `;
  const variables = {
    partnerUuid,
    parentSku,
    displayType: 'miti'
  };

  const param = 'query-tradeinItemConditionValues';

  try {
    const response = await fetchWithAppName(`${global.url}${param}`, {
      body: JSON.stringify({ query, variables }),
    });
    const jsonData = await response.json();
    const { tradeinItemConditionValues } = jsonData.data;
    const isKnownItemSku = tradeinItemConditionValues.parentSku !== null;

    if (tradeinItemConditionValues.availabilityMiti === 'INELIGIBLE') {
      return 'ineligible';
    }
    if (!isKnownItemSku) {
      return null;
    }
    return tradeinItemConditionValues;
  } catch (e) {
    console.error(e);
    return null;
  }
}

/**
 * Fetch the data from reware needed to display necessary form options (item departments,
 * categories, and trade-in values for each condition).
 *
 * @param {*} partnerUuid
 * @returns
 */
async function fetchDepartmentData(partnerUuid) {
  const query = `
    query tradeinDepartmentsFetch(
      $partnerUuid: String!
    ) {
      tradeinDepartments(partnerUuid: $partnerUuid) {
        name
        displayName
        categories {
          name
          displayName
          rubricCode
          subcategories {
            name
            displayName
            conditions {
              tradeinValue
              displayTradeinValue
              condition {
                name
                displayName
                rank
              }
            }
          }
          conditions {
            tradeinValue
            displayTradeinValue
            condition {
              name
              displayName
              rank
            }
          }
        }
      }
    }
  `;
  const param = 'query-tradeinDepartmentsFetch';
  try {
    const response = await fetchWithAppName(`${global.url}${param}`, {
      body: JSON.stringify({ query, variables: { partnerUuid } }),
    });
    const jsonData = await response.json();
    return jsonData.data;
  } catch (e) {
    console.log(e);
  }
}

async function fetchTradeinPromoDetails(partnerUuid, tradeinType) {
  const query = `
    query tradeinPromosFetch(
      $partnerUuid: String!
      $tradeinType: String!
    ) {
      tradeinPromoDetails(
        tradeinType: $tradeinType
        partnerUuid: $partnerUuid
      ) {
        code
        name
        termsAndConditions
      }
    }
  `;
  const param = 'query-tradeinPromosFetch';
  try {
    const response = await fetchWithAppName(`${global.url}${param}`, {
      body: JSON.stringify({ query, variables: { partnerUuid, tradeinType } }),
    });
    const jsonData = await response.json();
    return jsonData.data;
  } catch (e) {
    console.log(e);
  }
};

/* ---- DOM manipulation ---- */
const formInput = document.getElementById('search-area__input');
const searchButton = document.getElementById('search-area__submit-button');

const knownItemSection = document.querySelector('.trade-in-search .known-item');
const unknownItemSection = document.querySelector('.trade-in-search .unknown-item');

const addItemDetails = document.querySelector('.search-area__add-item-details') || document.getElementById('search-area__add-item-details');
const hideItemDetails = document.querySelector('.search-area__hide-item-details') || document.getElementById('search-area__hide-item-details');

const tradeinSearchForm = document.querySelector('trade-in-product-form');
const submitButtonContainer = document.querySelector('.trade-in-search-form__submit-button-container');
const addItemSubmitButton = document.getElementById('add-trade-in-item-button');
const styleNumberModal = document.querySelector('.style-number-modal');
const styleNumberOverlay = document.querySelector('.style-number-modal-overlay');
const searchAreaBodyP = document.querySelector('.search_area__body > p');
const styleModalClose = document.querySelector('.modal-close');
const [eligibleModalTrigger, styleModalTrigger] = searchAreaBodyP.getElementsByTagName('a');
const eligibilityModal = document.querySelector('.eligibility-modal');
const eligibilityModalClose = document.querySelector('.eligibility-modal-close');
const eligibilityOverlay = document.querySelector('.eligibility-modal-overlay');

function renderConditionModalOpeners(conditions, initialConditionEl, conditionListEl) {
  const conditionElements = conditions?.map((condition, i) => {
    const thisConditionEl = i === 0 ? initialConditionEl : initialConditionEl.cloneNode(true);
    const {
      tradeinValue,
      condition: {
        displayName,
        rank
      }
    } = condition;
    thisConditionEl.setAttribute('data-condition-rank', `${rank}`);

    thisConditionEl.querySelector('modal-opener').setAttribute('data-modal', `#modal-condition-rank-${rank}`);
    thisConditionEl.querySelector('.condition-name').innerHTML = displayName;
    const displayValue = tradeinValue ?
      ` - ${formatMoneyForTradein(tradeinValue)}` :
      '';

    thisConditionEl.querySelector('.condition-value').innerHTML = displayValue;
    return thisConditionEl;
  });

  conditionListEl.replaceChildren(...conditionElements);
  conditionListEl.classList.remove('hidden');
}

async function submitSearch(e) {
  e.preventDefault();
  const searchErrorMsg = document.getElementById('search-area__error-message');
  const knownItemSection = document.querySelector('.trade-in-search .known-item');
  const unknownItemSection = document.querySelector('.trade-in-search .unknown-item');
  const loadingElement = document.querySelector('.trade-in-search .loading-area');
  const findingYourStyleNumberSection = document.getElementById('finding-your-style-number');
  const noStyleNoProblemSection = document.getElementById('no-style-no-problem');
  const searchItemUnknownMessage = document.querySelector('.trade-in-search .search-area__unknown-item');
  const searchItemUnknownButton = document.querySelector('.search_area__add-item-button');
  const ineligibleItemMessage = document.querySelector('.trade-in-search .search-area__unavailable-item');

  const useUnknownFlow = localStorage.getItem("settings-use-unknown-flow") === 'true';

  knownItemSection.classList.add('hidden');
  unknownItemSection.classList.add('hidden');
  searchErrorMsg.classList.add('hidden');
  searchItemUnknownMessage.classList.add('hidden');
  submitButtonContainer.classList.add('hidden');
  ineligibleItemMessage.classList.add('hidden');
  addItemSubmitButton.disabled = false;

  const regexp = new RegExp(formInput.getAttribute('data-regexp-test'));
  if (!regexp.test(formInput.value)) {
    return (searchErrorMsg.classList.remove('hidden'));
  }
  sessionStorage.removeItem('tradeinPromoDetails');

  const tradeinPromoDetails = await fetchTradeinPromoDetails(global.partnerUuid, 'miti');
  if (tradeinPromoDetails) {
    sessionStorage.setItem('tradeinPromoDetails', JSON.stringify(tradeinPromoDetails));
  }
  // Fetch the item from reware
  const knownTradeinItem = await fetchSku(formInput.value, global.partnerUuid);
  if (knownTradeinItem) {
    if (knownTradeinItem === 'ineligible') {
      ineligibleItemMessage?.classList?.remove('hidden');
    } else {
      sessionStorage.setItem('currentTradeinItem', JSON.stringify(knownTradeinItem));
      window.location = `${Shopify.routes.root}pages/trade-in-eligibility`;
    }
  } else {
    tradeinSearchForm.setIsKnownItem(false);
    searchItemUnknownMessage.classList.remove('hidden');
    searchItemUnknownButton?.classList?.remove('hidden');

    if (useUnknownFlow) {
      findingYourStyleNumberSection?.classList?.add('hidden');
      noStyleNoProblemSection?.classList?.add('hidden');
    }
  }
}

async function showUnknownItemForm() {

  const departmentData  = await fetchDepartmentData(global.partnerUuid);

  sessionStorage.setItem('unknownItemDepartmentData', JSON.stringify(departmentData));

  window.location = `${Shopify.routes.root}pages/trade-in-alternative-lookup`;
}

function hideUnknownItemForm() {
  addItemDetails.classList.remove('hidden');
  hideItemDetails.classList.add('hidden');
  unknownItemSection.classList.add('hidden');
}

function handleDisableSubmitButton() {
  const addItemSubmitButton = document.getElementById('add-trade-in-item-button');
  const inputs = document.querySelectorAll('.form-input');

  const isFormFilled = [...inputs].every(input => {
    if (input.type === 'checkbox') {
      return input.checked;
    }
    if (input.type === 'radio' && input.checked) {
      return input.checked;
    }
    return Boolean(input.value);
  });

  if (isFormFilled) {
    addItemSubmitButton.disabled = false;
  } else {
    addItemSubmitButton.disabled = true;
  }
}

function openStyleModal() {
  styleNumberModal.classList.add('style-number-modal-open');
}

function openEligibilityModal() {
  eligibilityModal.classList.add('eligibility-modal-open');
}

function closeStyleModal() {
  styleNumberModal.classList.remove('style-number-modal-open');
}

function closeEligibilityModal() {
  eligibilityModal.classList.remove('eligibility-modal-open');
}

document.querySelectorAll('.form-input').forEach(input => {
  input.addEventListener('change', handleDisableSubmitButton)
});

searchButton.addEventListener('click', submitSearch);
searchButton.addEventListener('keypress', (event) => a11yKeyPress(event, submitSearch));
formInput.addEventListener('keypress', (event) => a11yKeyPress(event, submitSearch, false));

addItemDetails.addEventListener('click', showUnknownItemForm);
hideItemDetails.addEventListener('click', hideUnknownItemForm);

//Style number modal listeners
if (styleModalTrigger) {
  styleModalTrigger.addEventListener('click', openStyleModal);
  styleModalTrigger.classList.add('contains-tooltip');
}
styleNumberOverlay.addEventListener('click', closeStyleModal);
styleModalClose.addEventListener('click', closeStyleModal);

//Condition modal listeners
if (eligibleModalTrigger) eligibleModalTrigger.addEventListener('click', openEligibilityModal);
eligibilityModalClose.addEventListener('click', closeEligibilityModal);
eligibilityOverlay.addEventListener('click', closeEligibilityModal);

